module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t("editRepeatsView.setEstimatedLaps")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eventParticipant.estimatedRepeats),
      expression: "eventParticipant.estimatedRepeats"
    }],
    attrs: {
      "id": "estimatedRepeats",
      "type": "number",
      "disabled": _vm.eventParticipant.repeatsLocked
    },
    domProps: {
      "value": (_vm.eventParticipant.estimatedRepeats)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eventParticipant.estimatedRepeats = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("editRepeatsView.repeats")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.eventParticipant.repeats),
      expression: "eventParticipant.repeats"
    }],
    attrs: {
      "id": "repeats",
      "type": "number",
      "disabled": _vm.eventParticipant.repeatsLocked
    },
    domProps: {
      "value": (_vm.eventParticipant.repeats)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.eventParticipant.repeats = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button button-green",
    attrs: {
      "disabled": !_vm.isValidatedForSave
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("\r\n            " + _vm._s(_vm.$t("editRepeatsView.save")) + "\r\n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b27585e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/ts/views/EditRepeatsView.vue
// module id = 122
// module chunks = 0